export default __webpack_public_path__ + "static/media/labor_927_4.ee31da79.jpg";